import React from 'react';
import { Button, Col, Form, Icon, Row, Select, Upload } from 'antd';
import UploadInstructions from './UploadInstructions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Template from '@/files/people_template_v.2022.1.xls';

function UploadFormBody({
  form,
  fetchedGroupId,
  groups,
  location,
  file,
  setFile,
  onClose,
}) {
  const normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    if (e.fileList.length > 1) {
      e.fileList.shift();
    }
    return e && e.fileList;
  };

  return (
    <Row justify={'center'}>
      <Col style={{ paddingRight: 0 }} md={12}>
        <UploadInstructions />
      </Col>
      <Col
        style={{ paddingLeft: '34px', paddingRight: 0 }}
        className={'Form-container'}
        md={12}
      >
        <Form.Item>
          {form.getFieldDecorator('upload', {
            getValueFromEvent: normFile,
            rules: [
              {
                validator: (rule, value, cb) => {
                  if (!value || !value[0]) {
                    return cb('Excel file is required');
                  }
                  let _file = value[0];
                  if (
                    _file &&
                    (_file.type.indexOf('csv') > 0 ||
                      _file.type.indexOf('xlsx') > 0 ||
                      _file.type.indexOf('spreadsheetml.sheet') > 0 ||
                      _file.type.indexOf('opendocument.spreadsheet') > 0 ||
                      _file.type.indexOf('xls') > 0 ||
                      _file.type.indexOf('excel') > 0)
                  ) {
                    return cb();
                  } else {
                    return cb('File Format not Supported');
                  }
                },
              },
            ],
          })(
            <Upload.Dragger
              beforeUpload={file => {
                if (file) {
                  setFile(file);
                }
                return false;
              }}
              showUploadList={false}
            >
              <div className={'upload-placeholder'}>
                <div>
                  {file && file.name ? (
                    <React.Fragment>
                      {' '}
                      <p className='ant-upload-drag-icon'>
                        <Icon type='file-excel' />
                      </p>
                      <h3>{file.name}</h3>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <p className='ant-upload-drag-icon'>
                        <Icon type='inbox' />
                      </p>
                      <p className='ant-upload-text'>
                        <FormattedMessage
                          id='App.ImportFromFile.Info1'
                          defaultMessage={'Click here to upload the file'}
                        />
                      </p>
                      <p className='ant-upload-hint'>
                        <FormattedMessage
                          id='App.ImportFromFile.Info2'
                          defaultMessage={
                            'File must be in .xls or .xlsx format'
                          }
                        />
                      </p>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </Upload.Dragger>
          )}
        </Form.Item>
        <p
          style={{
            marginBottom: 0,
          }}
        >
          <FormattedMessage
            id='AddPeopleTo'
            defaultMessage='Add these people to'
          />
          :
        </p>
        <Form.Item>
          {form.getFieldDecorator('groupId', {
            initialValue: `${location ? location.pathname : ''}`.includes(
              '/groups/'
            )
              ? fetchedGroupId || ''
              : '',
          })(
            <Select>
              {/* new */}
              {/* <Select.Option key='everyone' value=''>
                <FormattedMessage id='everyone' defaultMessage='Everyone' />
              </Select.Option> */}
              <Select.Option key='select-group' value=''>
                <FormattedMessage
                  id='select-group'
                  defaultMessage='Select Group'
                />
              </Select.Option>
              {groups.map(opt => (
                <Select.Option key={opt.uuid} value={opt.uuid}>
                  {opt.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Col>
      <Col className={'footer-actions'} xs={24}>
        <Button className='downloadButton'>
          <a download href={Template} style={{ fontSize: '0.8rem' }}>
            <FormattedMessage
              id='App.Button.DownloadTemplate'
              defaultMessage={'Download template'}
            />
          </a>
        </Button>
        <div>
          <Button
            onClick={() => {
              onClose();
            }}
          >
            <FormattedMessage id='Button.Cancel' defaultMessage={'Cancel'} />
          </Button>
          <Button className={'upload-button'} type='primary' htmlType='submit'>
            <FormattedMessage
              id='Button.Continue'
              defaultMessage={'Continue'}
            />
          </Button>
        </div>
      </Col>
    </Row>
  );
}

export default UploadFormBody;
